import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ReactCountryFlag from 'react-country-flag';

import { withTranslation } from 'react-i18next';

import { logout } from '../../redux/actions/authActions';

import Icon1 from '../../assets/images/icon1.png';
import Logo from '../../assets/images/logo.png';
import Icon3 from '../../assets/images/icon3.png';
import Icon52 from '../../assets/images/icon52.png';
import Icon53 from '../../assets/images/icon53.png';

import i18n from '../../i18n';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: localStorage.getItem('I18N_LANGUAGE_KPNP'),
    };
  }

  async componentDidMount() {
    setTimeout(() => {
      console.log(localStorage.getItem('I18N_LANGUAGE_KPNP'));
      this.setState({ language: localStorage.getItem('I18N_LANGUAGE_KPNP') });
    }, 1000);
  }

  onFormSubmit = e => {
    e.preventDefault();
    alert('아직 준비중인 기능입니다.');
  };

  onClickLanguage = e => {
    e.preventDefault();
    const trigger = $(e.target).parent().parent();
    trigger.find('.dropdown-menu').slideToggle('fast');
  };

  onClickLanguageKorean = e => {
    e.preventDefault();
    const trigger = $(e.target).parent().parent();
    trigger.slideToggle('fast');

    i18n.changeLanguage('KOR');
    localStorage.setItem('I18N_LANGUAGE_KPNP', 'KOR');
    this.setState({ language: 'KOR' });
  };

  onClickLanguagEnglish = e => {
    e.preventDefault();
    const trigger = $(e.target).parent().parent();
    trigger.slideToggle('fast');

    i18n.changeLanguage('ENG');
    localStorage.setItem('I18N_LANGUAGE_KPNP', 'ENG');
    this.setState({ language: 'ENG' });
  };

  onClickViewSearch = e => {
    $('.serch').show();
    $('.tm_sic').show();
    $('.tm_si').hide();
  };

  onClickHideSearch = e => {
    $('.serch').hide();
    $('.tm_sic').hide();
    $('.tm_si').show();
  };

  renderUser = () => {
    const { authStatus, t } = this.props;

    if (authStatus) {
      const user = this.props.user.values.loggedInUser;

      let image = user.profile;
      if (image == null) image = Icon3;

      return (
        <ul>
          <li>
            <Link as="a" to="/mypage">
              <div
                className="top-profile"
                style={{ backgroundImage: `url('${image}')` }}
              />
              {t('{lastname}{firstname} 님 환영합니다.', {
                lastname: user.lastname,
                firstname: user.firstname,
              })}
            </Link>
          </li>

          <li>
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                this.props.logout();
              }}
            >
              <img src={Icon3} alt="sign in" />
              {t('로그아웃')}
            </a>
          </li>
          <li className="langauge-area">
            <div className="sub_menu">
              <ul>
                <li className="dropdown">
                  {this.state.language === 'KOR' ? (
                    <a href="#" className="flag" onClick={this.onClickLanguage}>
                      <ReactCountryFlag
                        countryCode="KR"
                        svg
                        style={{
                          width: '1.2em',
                          height: '1.2em',
                        }}
                      />
                      KOR
                    </a>
                  ) : (
                    <a href="#" className="flag" onClick={this.onClickLanguage}>
                      <ReactCountryFlag
                        countryCode="US"
                        svg
                        style={{
                          width: '1.2em',
                          height: '1.2em',
                        }}
                      />
                      ENG
                    </a>
                  )}

                  <ul className="dropdown-menu" style={{ display: 'none' }}>
                    <li onClick={this.onClickLanguageKorean}>
                      <a href="" className="flag">
                        <ReactCountryFlag
                          countryCode="KR"
                          svg
                          style={{
                            width: '1.2em',
                            height: '1.2em',
                          }}
                        />
                        KOR
                      </a>
                    </li>

                    <li onClick={this.onClickLanguagEnglish}>
                      <a href="" className="flag">
                        <ReactCountryFlag
                          countryCode="US"
                          svg
                          style={{
                            width: '1.2em',
                            height: '1.2em',
                          }}
                        />
                        ENG
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      );
    }
    return (
      <ul>
        <li>
          <Link as="a" to="/login">
            <img src={Icon3} alt="sign in" />
            {t('로그인')}
          </Link>
        </li>

        <li>
          <Link as="a" to="/join_agree">
            {t('회원가입')}
          </Link>
        </li>

        <li className="langauge-area">
          <div className="sub_menu">
            <ul>
              <li className="dropdown" onClick={this.onClickLanguage}>
                {this.state.language === 'KOR' ? (
                  <a href="#" className="flag">
                    <ReactCountryFlag
                      countryCode="KR"
                      svg
                      style={{
                        width: '1.2em',
                        height: '1.2em',
                      }}
                    />
                    KOR
                  </a>
                ) : (
                  <a href="#" className="flag">
                    <ReactCountryFlag
                      countryCode="US"
                      svg
                      style={{
                        width: '1.2em',
                        height: '1.2em',
                      }}
                    />
                    ENG
                  </a>
                )}

                <ul className="dropdown-menu" style={{ display: 'none' }}>
                  <li onClick={this.onClickLanguageKorean}>
                    <a href="" className="flag">
                      <ReactCountryFlag
                        countryCode="KR"
                        svg
                        style={{
                          width: '1.2em',
                          height: '1.2em',
                        }}
                      />
                      KOR
                    </a>
                  </li>

                  <li onClick={this.onClickLanguagEnglish}>
                    <a href="" className="flag">
                      <ReactCountryFlag
                        countryCode="US"
                        svg
                        style={{
                          width: '1.2em',
                          height: '1.2em',
                        }}
                      />
                      ENG
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    );
  };

  render() {
    const { authStatus, t } = this.props;

    return (
      <div id="header">
        <div className="h_inner">
          <div className="ami">
            <img src={Icon1} alt="" />
          </div>
          <h1>
            <Link as="a" to="/">
              <img src={Logo} alt="" />
            </Link>
          </h1>
          <div className="nav">
            <ul className="gnb">
              <li>
                <Link as="a" to="/event">
                  {t('대회')}
                </Link>
              </li>
              {/* <li>
                <a href="poomsae_list.html">ONLINE POOMSAE</a>
              </li> */}
              <li>
                <a href="http://www.kpnp.net" target="_blank" rel="noreferrer">
                  KPNP
                </a>
              </li>

              {authStatus &&
              this.props.user.userRole.find(
                item =>
                  item === 'judge' ||
                  item === 'site_operator' ||
                  item === 'site_admin',
              ) ? (
                <li>
                  <Link as="a" to="/competition/REF_DEMO">
                    {t('채점 시스템 데모')}
                  </Link>
                </li>
              ) : null}
              {/* <li>
                <a href="/community">COMMUNITY</a>
              </li> */}
            </ul>
          </div>
          {/* <div className="serch">
            <input type="text" />
            <button type="submit" className="" />
          </div> */}
          <div className="right_con">{this.renderUser()}</div>
          <div className="tm_si" onClick={this.onClickViewSearch}>
            <img src={Icon52} alt="" />
          </div>
          <div className="tm_sic" onClick={this.onClickHideSearch}>
            <img src={Icon53} alt="" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authStatus: state.auth.login.login,
    profile: state.auth.login.values,
    user: state.auth.login,
  };
};

export default connect(mapStateToProps, { logout })(withTranslation()(Header));
